type SafeStorage = {
	getItem: (name: string) => string | null;
	setItem: (name: string, value: string) => void;
	removeItem: (name: string) => void;
};

// SSR-safe storage that only accesses localStorage on the client
export const safeStorage: SafeStorage = {
	getItem: (name) => {
		if (typeof window === "undefined") return null;
		return localStorage.getItem(name);
	},
	setItem: (name, value) => {
		if (typeof window === "undefined") return;
		localStorage.setItem(name, value);
	},
	removeItem: (name) => {
		if (typeof window === "undefined") return;
		localStorage.removeItem(name);
	},
};
